import { combineReducers } from '@reduxjs/toolkit';
import workflowReducer from './slices/workflowSlice';
import projectReducer from './slices/projectSlice';
import exampleReducer from './slices/exampleSlice';
import mappingReducer from './slices/mappingSlice';
import entitiesReducer from './slices/entitiesSlice';
import dashboardReducer from './slices/dashboardSlice';
import connectionsReducer from './slices/connectionsSlice';

const rootReducer = combineReducers({
  workflows: workflowReducer,
  projects: projectReducer,
  example: exampleReducer,
  mapping: mappingReducer,
  entities: entitiesReducer,
  dashboard: dashboardReducer,
  connections: connectionsReducer,
});

export default rootReducer;
